import { ScientificAnalysisTemplateHeader } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'

export interface ScientificAnalysisTemplateHeaderVO{
    dto: ScientificAnalysisTemplateHeader
    selected: boolean
}

export interface ScientificAnalysisSearchTabTemplatesState {
    savedSearches: ScientificAnalysisTemplateHeaderVO[]
    selectSavedSearchesEnabled: boolean
}
export const initialScientificAnalysisSearchTabTemplatesState =
    (): ScientificAnalysisSearchTabTemplatesState => ({
        savedSearches: [],
        selectSavedSearchesEnabled: false
    })
